import { useLocation } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';
import LinkCard, { ProductLinkCard } from './LinkCard';

export default function RelatedProducts() {
  const { pathname } = useLocation();
  if (!pathname.startsWith('/resources/') && !pathname.startsWith('/case-studies/')) return null;
  const paths = /fee|finance|psi|eureka|cost/.test(pathname)
    ? ['/school-fee-management-software', '/school-management-system']
    : /attendance|biometric/.test(pathname) ? ['/school-attendance-system', '/parent-communication']
      : /student-information|admission/.test(pathname) ? ['/student-information-system', '/school-management-system']
        : /ai-|timetable/.test(pathname) ? ['/ai-school-management', '/school-management-system']
          : ['/school-management-system', '/best-learning-management-system-lahore-karachi-pakistan'];
  return <aside aria-label="Related product information" className="bg-blue-50 dark:bg-slate-800 py-14 px-4 sm:px-6">
    <div className="max-w-5xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-slate-900 dark:text-white">Explore the related school workflows</h2>
      <div className="grid gap-4 sm:grid-cols-3">
        {paths.map(path => <ProductLinkCard key={path} path={path} />)}
        <LinkCard to="/request-free-trial" icon={CalendarCheck} title="Request a demo" description="See the workflow with your school’s requirements" primary />
      </div>
    </div>
  </aside>;
}
